/// <amd-module name="Wit/WorkItems/DataSources/FieldFlagsDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { FieldStatusFlags } from "Wit/Clients/Internal/Contracts/SocialWorkItem";

const WorkItemFieldsEditStateDataProviderId = "ms.vss-work-web.field-edit-state-provider";

interface IAllowedValuesProviderRequestProperties {
    projectId: string;
    workItemId: number;
    workItemTypeName: string | undefined;
}

export async function getFieldFlags(
    pageContext: IVssPageContext,
    projectGuid: string,
    workItemId: number,
    workItemTypeName?: string
): Promise<{ [fieldRefName: string]: FieldStatusFlags } | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    const requestProperties: IAllowedValuesProviderRequestProperties = {
        projectId: projectGuid,
        workItemId,
        workItemTypeName
    };

    // Force a roundtrip
    const result = await contributionService.getDataAsync<{ [fieldRefName: string]: { fieldStatusFlags: FieldStatusFlags } }>(
        WorkItemFieldsEditStateDataProviderId,
        requestProperties,
        /* ignoreCache */ true
    );

    if (result) {
        let transformedResult: { [fieldRefName: string]: FieldStatusFlags } = {};
        Object.keys(result).forEach(refName => {
            transformedResult[refName] = result[refName].fieldStatusFlags;
        });
        return transformedResult;
    }
}
